if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // SD 2026-07-12: center the zoomed image reliably. Dawn's original ran
        // scrollIntoView() + a scrollLeft computed from the image's width at a
        // moment the image may not have LOADED yet (width 0 → corner-anchored
        // lightbox on phones), and mobile images rendered at NATURAL size
        // (3-5x screen — capped to 175vw in sd-theme.css). Now: wait for the
        // load when needed, then center BOTH axes on the active image.
        // Non-image media keep Dawn's original behavior.
        const container = this.querySelector('[role="document"]');
        const centerActive = () => {
          container.scrollTop = activeMedia.offsetTop + (activeMedia.clientHeight - container.clientHeight) / 2;
          container.scrollLeft = activeMedia.offsetLeft + (activeMedia.clientWidth - container.clientWidth) / 2;
        };
        // Center once now, and re-assert after layout settles — the load event
        // can fire a frame before the image's final size is laid out, which
        // made the first centering compute against a 0-width box.
        const settleCenter = () => {
          requestAnimationFrame(() => requestAnimationFrame(centerActive));
          setTimeout(centerActive, 180);
        };
        if (activeMedia.tagName === 'IMG') {
          // The modal imgs ship loading="lazy"; flip the tapped one to eager so
          // the fetch starts the instant the lightbox opens (some engines are
          // slow to observe intersection inside a just-displayed modal).
          activeMedia.loading = 'eager';
          if (activeMedia.complete && activeMedia.clientHeight > 0) {
            settleCenter();
          } else {
            activeMedia.addEventListener('load', settleCenter, { once: true });
          }
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
